import React, { useState, useEffect } from 'react';

import { Modal, Select, MenuItem } from '@material-ui/core';

import { CohortContext } from '../tab';

import { getCohortList } from '../../../../../services/apiService';

export default function ChangeCohortModal({ params, openModal, setOpenModal }) {
  const tableProps = React.useContext(CohortContext);

  const [selectedCohort, setSelectedCohort] = useState(null);
  const [reasonText, setReasonText] = useState('');
  const [errorMsg, setErrorMsg] = useState(null);

  const [cohortList, setCohortList] = useState(null);

  const cohortId = params?.data?.UserSubscriptions_cohortId;
  const cohortName = params?.data?.UserSubscriptions_cohortName;

  const courseType = params?.data?.UserSubscriptions_courseType;

  const fetchCohortList = async () => {
    try {
      const resp = await getCohortList(courseType);
      setCohortList(resp.filter((cohortItem) => cohortItem.id !== cohortId));
    } catch (err) {
      console.error(err);
      setErrorMsg('Error fetching cohort list.');
    }
  };

  useEffect(() => {
    if (openModal) fetchCohortList();
  }, [openModal]);

  return (
    <Modal open={openModal}>
      <div className='relative overflow-y-auto max-h-96 top-2 md:top-10 m-auto bg-ab-tertiary bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600 p-50'>
        <div
          className='absolute right-2 top-2 cursor-pointer'
          onClick={() => {
            setOpenModal(false);
          }}
        >
          X
        </div>
        <h2 className='font-bold text-center text-lg'>cohort</h2>

        <div className='mx-4'>
          <div>
            Current cohort: <span className='font-bold'>{cohortName}</span>
          </div>

          <div className='mt-2'>Choose new cohort:</div>
          <Select
            // labelId='demo-simple-select-helper-label'
            // id='demo-simple-select-helper'
            name='courseType'
            id='courseType'
            variant='outlined'
            className='w-64'
            value={selectedCohort}
            onChange={(event) => {
              setSelectedCohort(event.target.value);
            }}
          >
            {cohortList &&
              cohortList.map((item, i) => (
                <MenuItem key={i} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
          </Select>

          <div className='mt-2'>Reason:</div>
          <textarea
            className='w-full border border-gray-300 focus:outline-none focus:border-blue-c1 focus:ring-1 focus:ring-blue-c1 rounded-lg p-2'
            value={reasonText}
            onChange={(event) => {
              setReasonText(event.target.value);
            }}
          />

          <div className='mt-2'>
            Note: The changes will be reflected after 5 minutes.
          </div>
        </div>

        <hr />
        <div className='flex justify-end items-center mt-4'>
          {errorMsg && (
            <div className='text-red-c3 mr-2 text-sm'>{errorMsg}</div>
          )}
          <button
            className='bg-red-c3 p-1 px-2 rounded-md text-white'
            onClick={() => {
              setErrorMsg(null);

              if (!selectedCohort) {
                setErrorMsg('Please select a cohort');
                return;
              }
              if (reasonText.trim() === '') {
                setErrorMsg('Reason cannot be empty');
                return;
              }

              tableProps.cohortChangeFn(
                params.data.UserSubscriptions_courseType,
                params.data.id,
                selectedCohort,
                reasonText
              );
              setOpenModal(false);
            }}
          >
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
}
